import axios from "axios";
import axiosTime from "axios-time";

const geocode = "https://maps.googleapis.com/maps/api/geocode/json";
const apiGiorniDisponibili = `${process.env.REACT_APP_SERVICES_API_PATH}/api/ChatBot/GiorniDisponibili`;
const apiElencoFiliali = `${process.env.REACT_APP_SERVICES_API_PATH}/api/ChatBot/ElencoFiliali`;
const apiOrariDisponibili = `${process.env.REACT_APP_SERVICES_API_PATH}/api/ChatBot/OrariDisponibili`;
const apiCheckByCF = `${process.env.REACT_APP_SERVICES_API_PATH}/api/ChatBot/CheckByCFAsync`;
const apiGetToken = `${process.env.REACT_APP_TOKEN_API_PATH}`;

axiosTime(axios);

export const getGeocodeAddress = (params) =>
    axios.get(geocode, {
        params: params
    });

export const getGiorniDisponibili = (params) =>
    axios.post(apiGiorniDisponibili, params)

export const getElencoFiliali = (params) =>
    axios.post(apiElencoFiliali, params)

export const getOrariDisponibili = (params) =>
    axios.post(apiOrariDisponibili, params)

export const checkByCF = (params) =>
    axios.post(apiCheckByCF, params)

// export const getToken = (params) =>
//     axios.post(apiGetToken, params)

export const getToken = (params) => {
    // Define the headers and data to be sent in the request
    const headers = {
        'Content-Type': 'application/json',
        // 'Cookie': '2u9PDBrj70CWfxF-fmICpQ=!94hJLsHuz72wOynPmyneaZ5+0E9IJcKRQvTI2VBUmrYGCGT1FxiyxGGqgMdzfLql6gUHSG08iLs/TII=; TS0177f988=0193d1e4817c1c9294891bd4bf6dd6adf7bab83f87ba9563f790840a5ba3426a30e9df9a27cd2229ea7fdaddfd6a6c7d5d7a41c342; clicktrack=3cee8614.614b93298b6df'
    };

    const data = {
        "isB2BChat": true,
        "AppCode": "CHATBOT",
        "elencoParametri": [
            {
                "keyCode": "nome",
                "valore": params.nome
            },
            {
                "keyCode": "cognome",
                "valore": params.cognome
            },
            {
                "keyCode": "codiceFiscale",
                "valore": params.codiceFiscale
            },
            {
                "keyCode": "email",
                "valore": params.email
            },
            {
                "keyCode": "telefonoCell",
                "valore": params.telefonoCell
            },
            {
                "keyCode": "telefono",
                "valore": params.telefono
            },
            {
                "keyCode": "user_cap",
                "valore": params.cap
            },
        ]
    };

    // Send the post request with axios
    return axios.post(apiGetToken, data, headers);
};